import React, { useState } from "react";
import { GrFormClose } from "react-icons/gr";

import * as Styles from "./styles";

interface Props {
  open: boolean;
  setOpenModal: any;
  component?: JSX.Element;
  title?: string;
  saveText?: string;
  closeText?: string;
  titleHeader?: string;
  onClose: Function;
  onClean?: Function;
  onSave: Function;
  isRight?: boolean;
  width?: number | string;
  height?: number;
  borderRadius?: number;
  maxHeight?: string;
  loading?: boolean;
  isFilter: boolean;
  isClose?: boolean;
  icon?: any;
  isLogin?: boolean;
  marginBottom?: number;
  blockClose?: boolean;
}
const DialogCommon: React.FC<Props> = ({
  open,
  setOpenModal,
  component,
  title,
  height,
  maxHeight,
  onClose,
  isRight,
  width,
  icon,
  titleHeader,
  isLogin,
  borderRadius,
  blockClose = false,
}) => {
  const [dialogShake, setDialogShake] = useState<boolean>(false);

  const handleBDClick = () => {
    setDialogShake(true);
    const delayDebounceFn = setTimeout(() => {
      setDialogShake(false);
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  };

  return (
    <Styles.Modal
      PaperProps={{
        style: {
          borderRadius: borderRadius || 4,
          position: isRight ? "absolute" : "relative",
          top: isRight ? 40 : 0,
          right: isRight ? 10 : 0,
          display: "flex",
          height: height || "auto",
          maxHeight: maxHeight || "auto",
        },
      }}
      open={open}
      disableEscapeKeyDown={blockClose}
      onClose={(event, reason) => {
        if (blockClose) {
          handleBDClick();
          return;
        }

        if (reason !== "backdropClick") {
          setOpenModal(false);
          onClose();
        } else {
          handleBDClick();
        }
      }}
      className={`shake-${dialogShake}`}
    >
      <Styles.DialogHeader>
        <Styles.Header>
          <Styles.TitleHeader>
            {icon}
            {titleHeader}
            {title === "Histórico" && title}
          </Styles.TitleHeader>
          {!isLogin && !blockClose && (
            <Styles.IconButton
              onClick={() => {
                onClose();
                setOpenModal(false);
              }}
            >
              <GrFormClose />
            </Styles.IconButton>
          )}
        </Styles.Header>
        {title !== "Histórico" ? (
          <Styles.TitleHeaderTwo>{title}</Styles.TitleHeaderTwo>
        ) : null}
      </Styles.DialogHeader>
      <Styles.ContainerModal style={{ width: width || 500 }}>
        {component}
      </Styles.ContainerModal>
    </Styles.Modal>
  );
};
export default DialogCommon;
